/**
 * Runtime config from Vue CLI env vars (`.env.development` / `.env.production`).
 * Client-only values — no secrets (Stripe secret keys stay in backend `.env`).
 *
 * NOTE on dev-mode CORS:
 * ``VUE_APP_API_BASE_URL`` is **baked into the bundle when `vue-cli-service
 * serve` starts** — editing `.env.development` after the dev server is
 * already running has no effect. If you edit env vars, restart `npm run
 * serve`. Previously this file silently fell back to the production Flask
 * origin, which then rejected `Origin: http://localhost:8080` with a 403 +
 * no ACAO header — the browser reports it as a CORS block, but the real
 * cause is a mis-set env var. The `apiBaseUrl` getter below now throws
 * loudly in dev instead so this footgun can't reoccur.
 */

function env(name, fallback = '') {
  const value = process.env[name];
  if (value == null || String(value).trim() === '') {
    return fallback;
  }
  return String(value).trim();
}

function requiredEnv(name) {
  const value = process.env[name];
  if (value == null || String(value).trim() === '') {
    const msg = (
      `[coinproof] required env var ${name} is missing. In dev, set it in ` +
      `development/frontend/coinproof.ai/.env.development and restart ` +
      `\`npm run serve\` (Vue CLI bakes env at server start; hot-reload does not pick up env changes).`
    );
    // Fail loud in the browser console instead of silently defaulting to
    // the production API, which then 403s cross-origin from localhost.
    throw new Error(msg);
  }
  return String(value).trim();
}

/** Flask API origin — no trailing slash. Required; no silent fallback. */
export const apiBaseUrl = requiredEnv('VUE_APP_API_BASE_URL');

/** Static assets (coin/exchange icons) — prod CDN by default. */
export const assetBaseUrl = env('VUE_APP_ASSET_BASE_URL', 'https://coinproof.ai');

/**
 * GA4 Measurement ID (G-XXXXXXXX). Empty = analytics off (laptop default).
 * Do not confuse with Firebase `measurementId` — that is a separate Firebase Analytics stream.
 */
export const analyticsId = env('VUE_APP_ANALYTICS_ID');

export const firebaseConfig = {
  apiKey: env('VUE_APP_FIREBASE_API_KEY', 'AIzaSyBiXhbtXHageJonT2fhUR0w0RNyngIJ5Mc'),
  authDomain: env('VUE_APP_FIREBASE_AUTH_DOMAIN', 'coinproof-c66d5.firebaseapp.com'),
  projectId: env('VUE_APP_FIREBASE_PROJECT_ID', 'coinproof-c66d5'),
  storageBucket: env('VUE_APP_FIREBASE_STORAGE_BUCKET', 'coinproof-c66d5.firebasestorage.app'),
  messagingSenderId: env('VUE_APP_FIREBASE_MESSAGING_SENDER_ID', '525435218954'),
  appId: env('VUE_APP_FIREBASE_APP_ID', '1:525435218954:web:3b8dec2bd752da353583f3'),
  measurementId: env('VUE_APP_FIREBASE_MEASUREMENT_ID', 'G-31QV1TE506'),
};

/** Build a Flask endpoint URL from a path segment (e.g. `get-data`). */
export function apiUrl(path) {
  const segment = path.startsWith('/') ? path.slice(1) : path;
  return `${apiBaseUrl}/${segment}`;
}
